import React, {useEffect} from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import ScreenWrapper from "@hoc/ScreenWrapper";
import { ThemedText, ThemedView } from "@app/theme";
import LottieView from "lottie-react-native";
import { useAppSelector } from "@store/hooks";
import { usePolling } from './hooks/usePolling';
import { useLoadingAnimation } from './hooks/useLoadingAnimation';
import { LoadingAnimation } from './components/LoadingAnimation';

type ScreenProps = NativeStackScreenProps<
    PrivateStackParamList,
    'MFC_FETCH_EVALUTE_FUNDS'
>;

const MFCentralEvaluateFunds: React.FC<ScreenProps> = ({ route }) => {
    const { userDetails } = useAppSelector(state => state.auth);
    const applicationId = userDetails.linkedApplications[0].applicationId;
    usePolling({ applicationId });


    const { currentMessage, currentDots, fadeAnim } = useLoadingAnimation();

    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            <ThemedView backgroundColor="bg-surface-primary" flex={1} justifyContent={"center"}>
                <ThemedView>
                    <ThemedText
                        textAlign={"center"}
                        variant={"h3s"}
                        color={"text-primary"}
                    >
                        Evaluating your mutual funds
                    </ThemedText>

                    <LottieView
                        source={require('../../../assets/lottie/fetch_funds_animation.json')}
                        loop={true}
                        autoPlay={true}
                        style={{ width: 340, height: 170, alignSelf: 'center', marginTop: 40, marginBottom: 40 }}
                    />

                    <ThemedView alignSelf={"center"}>
                        <LoadingAnimation
                            message={currentMessage}
                            dots={currentDots}
                            fadeAnim={fadeAnim}
                        />
                    </ThemedView>
                </ThemedView>
            </ThemedView>
        </ScreenWrapper>
    );
};

export default MFCentralEvaluateFunds;